import type { Blast, BlastChannel, BlastStatus } from '../../types'
import type { BlastAction } from '@components/molecules/BlastRowActions'
import { blastUrl, editBlastUrl, submitBlastUrl } from '../../utils/routes'
import {
  canApprove,
  canCancel,
  canDelete,
  canEdit,
  canSubmit,
  unavailableReasonKey,
  type BlastPermissions,
} from '../../utils/blastPermissions'

export function buildBlastAction({
  blast,
  channel,
  permissions,
  currentUserId,
  reasonFor,
  onDeleted,
}: {
  blast: Blast
  channel: BlastChannel
  permissions: BlastPermissions
  currentUserId: string
  reasonFor: (status: BlastStatus) => string | null
  onDeleted?: () => void
}): BlastAction {
  const status = blast.status as BlastStatus
  const recipients = blast.audience.kind

  return {
    showApprove: canApprove(status, permissions),
    showSubmit: canSubmit(status, blast.authorId ?? null, currentUserId, permissions),
    showCancel: canCancel(status, blast.authorId ?? null, currentUserId, permissions),
    canEdit: canEdit(status, blast.authorId ?? null, currentUserId, permissions),
    canDelete: canDelete(status, permissions),
    reason: unavailableReasonKey(status) ? reasonFor(status) : null,
    blastUrl: blastUrl(channel, blast.id),
    editUrl: editBlastUrl(channel, blast.id, recipients),
    submitUrl: submitBlastUrl(channel, blast.id),
    title: blast.title ?? '',
    onDeleted,
  }
}
